import React from 'react';
import { FH132 } from '../../../services/pwh203Api';

interface Props {
  expenses: FH132[];
  isEditing: boolean;
}

const Tab3Expenses: React.FC<Props> = React.memo(({ expenses, isEditing }) => {
  const total = expenses.reduce((sum, e) => sum + (e.fh132_13 || 0), 0);

  return (
    <div className="pwh203-tab-content">
      <div className="pwh203-table-wrapper">
        <table className="pwh203-table">
          <thead>
            <tr>
              <th style={{ width: 55 }}>沖帳單號</th>
              <th style={{ width: 45 }}>明細序號</th>
              <th style={{ width: 45 }}>費用序號</th>
              <th style={{ width: 100 }}>費用代號</th>
              <th style={{ width: 100 }}>廠商代號</th>
              <th style={{ width: 100 }}>備用代碼</th>
              <th style={{ width: 120 }}>費用金額</th>
            </tr>
          </thead>
          <tbody>
            {expenses.map((row, idx) => (
              <tr key={idx}>
                <td className="text-center">{row.fh132_01}</td>
                <td className="text-center">{row.fh132_02}</td>
                <td className="text-center">{row.fh132_03}</td>
                <td>
                  <input
                    className="cell-input"
                    value={row.fh132_10}
                    disabled
                    readOnly
                  />
                </td>
                <td>
                  <input
                    className="cell-input"
                    value={row.fh132_11}
                    disabled
                    readOnly
                  />
                </td>
                <td>
                  <input
                    className="cell-input"
                    value={row.fh132_12}
                    disabled
                    readOnly
                  />
                </td>
                <td>
                  <input
                    className="cell-input text-right"
                    value={row.fh132_13.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    disabled
                    readOnly
                  />
                </td>
              </tr>
            ))}
            {expenses.length === 0 && (
              <tr>
                <td colSpan={7} className="text-center no-data">
                  尚無費用分攤資料
                </td>
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr className="total-row">
              <td colSpan={6} className="text-right"><strong>合計</strong></td>
              <td className="text-right">
                <strong>{total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      {isEditing && (
        <p className="tab-note">費用分攤由系統根據明細自動維護，不可直接編輯。</p>
      )}
    </div>
  );
});

export default Tab3Expenses;
